import logoImg from '../assets/images/logo.png';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../store/zustand';
import { useThemeMode } from '../hooks/useThemeMode';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { IonIcon } from '@ionic/react';
import {
  closeOutline,
  logInOutline,
  logOutOutline,
  menuOutline,
  moonOutline,
  personOutline,
  settingsOutline,
} from 'ionicons/icons';
import Avatar from './Avatar';
import HeaderNotifications from './HeaderNotifications';

const Header = () => {
  const { t } = useTranslation();
  const { _toogleDarkMode, isDarkMode } = useThemeMode();

  const currentUser = useAuthStore((state) => state.user);

  return (
    <header className="z-[100] h-[--m-top] fixed top-0 left-0 w-full flex items-center bg-white/80 sky-50 backdrop-blur-xl border-b border-slate-200 dark:bg-dark2 dark:border-slate-800">
      <div className="flex items-center w-full xl:px-6 px-2 max-lg:gap-10">
        <div className="2xl:w-[--w-side] lg:w-[--w-side-sm]">
          <div className="flex items-center gap-1">
            <button
              data-uk-toggle="target: #site__sidebar ; cls :!-translate-x-0"
              className="flex items-center justify-center w-8 h-8 text-xl rounded-full hover:bg-gray-100 xl:hidden dark:hover:bg-slate-600 group"
            >
              <IonIcon
                icon={menuOutline}
                className="text-2xl group-aria-expanded:hidden"
              />
              <IonIcon
                icon={closeOutline}
                className="hidden text-2xl group-aria-expanded:block"
              />
            </button>

            <div id="logo">
              <a href="/">
                <img
                  src={logoImg}
                  alt="Playsum Logo"
                  className="md:block hidden h-6 sm:h-8 w-auto"
                />
                <img
                  src={logoImg}
                  className="hidden max-md:block h-6 sm:h-8 w-auto"
                  alt="Playsum Logo"
                />
              </a>
            </div>
          </div>
        </div>
        <div className="flex-1 relative">
          <div className="max-w-[1220px] mx-auto flex items-center">
            <div className="flex items-center sm:gap-4 gap-2 absolute right-5 top-1/2 -translate-y-1/2 text-black">
              {currentUser ? (
                <>
                  <HeaderNotifications />

                  <div className="rounded-full relative cursor-pointer shrink-0 sm:w-9 sm:h-9 w-7 h-7 ">
                    <Avatar
                      userId={currentUser?.id}
                      username={currentUser?.username}
                    />
                  </div>
                </>
              ) : (
                <button
                  type="button"
                  className="py-0.5 px-1 sm:w-9 sm:h-9 w-7 h-7 relative rounded-full shadow object-cover ring-1 ring-neutral-200 dark:ring-neutral-400 dark:text-white"
                >
                  <IonIcon
                    icon={personOutline}
                    className="text-xl align-middle"
                  />
                </button>
              )}

              <div
                className="hidden bg-white rounded-lg drop-shadow-xl dark:bg-slate-800 w-64 border2 absolute z-50 [.uk-open]:block"
                data-uk-drop="offset:6;pos: bottom-right;animate-out: true; animation: uk-animation-scale-up uk-transform-origin-top-right "
              >
                {currentUser && (
                  <>
                    <div className="p-4 py-5 flex items-center gap-4">
                      <Link
                        to={`/user/${currentUser?.id}`}
                        className="w-10 h-10 "
                      >
                        <Avatar
                          userId={currentUser?.id as string}
                          username={currentUser?.username}
                        />
                      </Link>
                      <div className="flex-1">
                        <h4 className="text-sm font-medium text-black">
                          {currentUser?.username}
                        </h4>
                        <div className="text-sm mt-1 text-neutral-500 dark:text-neutral-400">
                          {currentUser?.email}
                        </div>
                      </div>
                    </div>

                    <hr className="dark:border-gray-600/60" />
                  </>
                )}

                <nav className="p-2 text-sm text-black font-normal dark:text-white">
                  {currentUser && (
                    <Link to={'/account'}>
                      <div className="flex items-center gap-2.5 hover:bg-secondery p-2 px-2.5 rounded-md dark:hover:bg-white/10">
                        <IonIcon icon={settingsOutline} className="w-6 h-6" />
                        {t('Header.settings')}
                      </div>
                    </Link>
                  )}
                  <button type="button" className="w-full">
                    <div className="flex items-center gap-2.5 hover:bg-secondery p-2 px-2.5 rounded-md dark:hover:bg-white/10">
                      <IonIcon icon={moonOutline} className="w-6 h-6" />

                      {t('Header.darkTheme')}
                      <span className="ml-auto p-0.5">
                        <label className="switch inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            defaultChecked={isDarkMode}
                            onClick={_toogleDarkMode}
                          />
                          <span className="switch-button !relative"></span>
                        </label>
                      </span>
                    </div>
                  </button>

                  <hr className="-mx-2 my-2 dark:border-gray-600/60" />

                  {currentUser ? (
                    <Link to={'/logout'}>
                      <div className="flex items-center gap-2.5 hover:bg-secondery p-2 px-2.5 rounded-md dark:hover:bg-white/10">
                        <IonIcon icon={logOutOutline} className="w-6 h-6" />

                        {t('Header.logout')}
                      </div>
                    </Link>
                  ) : (
                    <Link to={'/login'}>
                      <div className="flex items-center gap-2.5 hover:bg-secondery p-2 px-2.5 rounded-md dark:hover:bg-white/10">
                        <IonIcon icon={logInOutline} className="w-6 h-6" />
                        {t('Header.login')}
                      </div>
                    </Link>
                  )}
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
